import { Button } from '@tovala/component-library'
import { events } from 'analytics/events'
import ConfirmationDialog, {
  ConfirmationBody,
  ConfirmationButtons,
  ConfirmationHeader,
} from 'components/common/ConfirmationDialog'
import { useEffect } from 'react'
import { track } from 'utils/analytics'
import { getLocalStorageItem, setLocalStorageItem } from 'utils/storage'

export const LOCAL_STORAGE_KEY = 'hasViewedFamilyMealsWarning'

const FamilyMealConfirmationDialog = ({
  onClose,
  onConfirm,
  trackMetadata,
}: {
  onClose: () => void
  onConfirm: () => void
  trackMetadata: {
    mealID: number
    termID: number
  }
}) => {
  useEffect(() => {
    setLocalStorageItem<boolean>(LOCAL_STORAGE_KEY, true)
  }, [])

  useEffect(() => {
    track(events.DID_SHOW_FAMILY_MEAL_WARNING, trackMetadata)
  }, [trackMetadata])

  return (
    <ConfirmationDialog onRequestClose={onClose}>
      <ConfirmationHeader
        heading="You're adding a Family Meal"
        onClickClose={onClose}
      />
      <ConfirmationBody>
        <div className="flex flex-col items-center space-y-6 py-20 md:py-12">
          <p className="mx-auto max-w-sm text-body-lg">
            This meal <strong>serves 4</strong> and{' '}
            <strong>must be cooked together</strong> at the same time. Do you
            want to add it to your order?
          </p>
        </div>
      </ConfirmationBody>
      <ConfirmationButtons>
        <div className="grid grid-cols-1 gap-2">
          <Button
            onClick={() => {
              track(events.DID_TAP_CONFIRM_FAMILY_MEAL, trackMetadata)
              onConfirm()
            }}
            size="large"
            type="submit"
          >
            Yes, add Family Meal
          </Button>
          <Button
            buttonStyle="stroke"
            onClick={() => {
              track(events.DID_TAP_CANCEL_FAMILY_MEAL, trackMetadata)
              onClose()
            }}
            size="large"
          >
            No, don't add Family Meal
          </Button>
        </div>
      </ConfirmationButtons>
    </ConfirmationDialog>
  )
}

export default FamilyMealConfirmationDialog

export function getHasViewedFamilyMealsWarning() {
  return getLocalStorageItem<boolean>(LOCAL_STORAGE_KEY) ?? false
}
